module.exports = __webpack_public_path__ + "img/me_outside.1516b321.jpg";